import { useRef } from 'react'
import styles from './QA.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface Props {
  contents: {
    num: number
    question: string
    answer: string
  }[]
}

const QA: React.FC<Props> = ({ contents }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.qa} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.qaTitle}>よくあるご質問</h2>
        <ul className={styles.qaList}>
          {contents.map((item, i) => (
            <li key={i} className={styles.qaList__item}>
              <div className={styles.qaList__item__question}>
                <div className={styles.qaList__item__question__mark}>Q</div>
                <p className={styles.qaList__item__question__text}>{item.question}</p>
              </div>
              <div className={styles.qaList__item__answer}>
                <div className={styles.qaList__item__answer__mark}>A</div>
                <p className={styles.qaList__item__answer__text}>{item.answer}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
export default QA
